// Generated by GitHub Copilot

/**
 * `raw` when it is an in-app path a sign-in may land on, else undefined. An absolute URL or a
 * protocol-relative "//host" would turn the landing into an open redirect, and /login or /logout
 * would bounce forever.
 */
export function safeInAppPath(raw: unknown): string | undefined {
  return typeof raw === 'string' && /^\/(?!\/)/.test(raw) && !/^\/log(in|out)\b/.test(raw) ? raw : undefined
}

/**
 * Opens the app on `destination` with a freshly stored session: drops the tab's session state so the
 * new session is read from scratch, then loads the page in full.
 *
 * @param keep Session-storage entries to write after the clear, for the page that loads next.
 */
export function enterApp(destination: string, keep: Record<string, string> = {}): void {
  sessionStorage.clear()
  for (const [key, value] of Object.entries(keep)) sessionStorage.setItem(key, value)
  document.location.href = destination
}
